import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { CustomFormsModule } from 'ngx-custom-validators';
import { AuthenticationGuardService } from './auth-guard.service';
import { AuthenticationRoutes } from './auth.routing';
import { AuthService } from './auth.service';
import { JwtInterceptor } from './jwt.interceptor';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { ResetpwdComponent } from './resetpwd/resetpwd.component';
import { TokenInterceptor } from './token.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreComponentsModule } from '../core-components/core-components.module';

const SERVICES = [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptor,
    multi: true
  }, 
  AuthService, 
  AuthenticationGuardService,
  CookieService
];
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CustomFormsModule,
    TranslateModule,
    NgbModule,
	CoreComponentsModule,
    RouterModule.forChild(AuthenticationRoutes)
  ],
  declarations: [
    LoginComponent,
    LogoutComponent,
    ResetpwdComponent
  ],
  providers: [
    ...SERVICES,
  ],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: AuthModule,
      providers: [
        ...SERVICES,
      ],
    };
  }
}
